import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, UserCog } from "lucide-react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Avatar, AvatarFallback } from "../components/ui/avatar";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";

export default function SuperUsers() {
  const [users, setUsers] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "Welcome!2026" });

  const load = () => api.get("/admin/super-users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name || !form.email) return;
    try { await api.post("/admin/super-users", form); toast.success("Super user added"); setOpen(false); setForm({ name: "", email: "", password: "Welcome!2026" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  if (!users) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--accent))]" /></div>;

  return (
    <div>
      <PageHeader title="Super Users" subtitle="SEQ / Amden platform administrators with full access to all clients.">
        <Button className="rounded-full" onClick={() => setOpen(true)} data-testid="add-super-user-btn"><Plus className="mr-2 h-4 w-4" /> Add Super User</Button>
      </PageHeader>

      <Card className="overflow-hidden rounded-2xl border-border">
        {users.map((u) => (
          <div key={u.id} className="flex items-center justify-between border-b border-border/60 px-5 py-3.5 last:border-0" data-testid={`super-user-${u.email}`}>
            <div className="flex items-center gap-3">
              <Avatar className="h-9 w-9"><AvatarFallback className="bg-violet-500/15 text-sm text-violet-600 dark:text-violet-400">{u.name?.[0]}</AvatarFallback></Avatar>
              <div><div className="text-sm font-medium">{u.name}</div><div className="text-xs text-muted-foreground">{u.email}</div></div>
            </div>
            <Badge className="rounded-full bg-violet-500/10 text-violet-600 dark:text-violet-400"><UserCog className="mr-1 h-3 w-3" /> Super Admin</Badge>
          </div>
        ))}
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-heading">Add Super User</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1.5"><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="su-name" /></div>
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="su-email" /></div>
            <div className="space-y-1.5"><Label>Temporary password</Label><Input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="su-password" /></div>
          </div>
          <DialogFooter><Button onClick={create} className="rounded-full" data-testid="su-save-btn">Create</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
